"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolveWidgetTargetSection = exports.resolveTargetSection = exports.WIDGET_SELECTOR_PREFIX = exports.WIDGET_PRIORITY_ORDER = exports.WIDGET_CONTAINER_SELECTOR = exports.DEFAULT_TARGET_SECTION_ID = exports.DEFAULT_BREADCRUMBS_TARGET_ID = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var DEFAULT_TARGET_SECTION_ID = 'main-content-target';
exports.DEFAULT_TARGET_SECTION_ID = DEFAULT_TARGET_SECTION_ID;
var DEFAULT_BREADCRUMBS_TARGET_ID = 'breadcrumbs-target';
exports.DEFAULT_BREADCRUMBS_TARGET_ID = DEFAULT_BREADCRUMBS_TARGET_ID;
var WIDGET_CONTAINER_SELECTOR = '.widget-container';
exports.WIDGET_CONTAINER_SELECTOR = WIDGET_CONTAINER_SELECTOR;
var WIDGET_SELECTOR_PREFIX = 'widget-container--';
exports.WIDGET_SELECTOR_PREFIX = WIDGET_SELECTOR_PREFIX;
var WIDGET_PRIORITY_ORDER = ['category_and_topics_stream_only', 'ideation_list', 'product-updates_list', 'event-overview_list', 'knowledge_base', 'featured_topics', 'quick_links', 'hero_banner', 'topic_banner'];
exports.WIDGET_PRIORITY_ORDER = WIDGET_PRIORITY_ORDER;

var resolveWidgetTargetSection = function resolveWidgetTargetSection() {
  var widgetContainers = Array.from(document.querySelectorAll(WIDGET_CONTAINER_SELECTOR));

  var _iterator = _createForOfIteratorHelper(WIDGET_PRIORITY_ORDER),
      _step;

  try {
    var _loop = function _loop() {
      var widget = _step.value;
      var widgetContainer = widgetContainers.find(function (container) {
        return container.classList.contains("".concat(WIDGET_SELECTOR_PREFIX).concat(widget));
      });

      if (widgetContainer) {
        return {
          v: widgetContainer
        };
      }
    };

    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _ret = _loop();

      if ((0, _typeof2.default)(_ret) === "object") return _ret.v;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return null;
};

exports.resolveWidgetTargetSection = resolveWidgetTargetSection;

var resolveTargetSection = function resolveTargetSection() {
  var isDynamicPage = document.querySelectorAll(WIDGET_CONTAINER_SELECTOR).length > 1;
  return isDynamicPage ? resolveWidgetTargetSection() : null;
};

exports.resolveTargetSection = resolveTargetSection;